import { restrictions } from 'state/features-list/constants';
import { createFlowRoutes } from 'pages/wpo-appointments/create-flow-routes';

import {
  WLS_APPOINTMENTS_URL_PREFIX,
  WlsAppointmentsRoutes,
} from './state/constants';
import { shouldGrantAccessToWlsAppointmentsFlow } from './state/helpers';

const wlsAppointmentsModule = createFlowRoutes({
  urlPrefix: WLS_APPOINTMENTS_URL_PREFIX,
  routeNames: WlsAppointmentsRoutes,
  shouldGrantAccess: shouldGrantAccessToWlsAppointmentsFlow,
  restrictions: { user: [restrictions.wpo_wls_scheduling] },
  introTitleKey: 'appointments.wls_appointment_intro.title',
});

export default wlsAppointmentsModule;
